export type MfaContactType = 'Email' | 'Sms' | 'None'

export const MfaContactType = {
  None: 'None' as MfaContactType,
  Email: 'Email' as MfaContactType,
  Sms: 'Sms' as MfaContactType,
}
